// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const SummaryNotes = ({ summaryNotes }) => {
  const { t } = useTranslation();

  return (
    <div className="summary-notes">
      <h6 className="title is-6 is-primary-color summary-notes__title">
        {t('engagement_report.summary_notes')}
      </h6>
      {summaryNotes}
    </div>
  );
};

SummaryNotes.propTypes = {
  summaryNotes: PropTypes.string.isRequired,
};

export default SummaryNotes;
